export default __webpack_public_path__ + "static/media/hoh.357cd046.svg";